import React from 'react';

const PersonalizedNutrientProfileLabels = (props) => {
  const {data} = props;

  return (
    <thead>
      <tr>
        {data.map((label, index) => (
          <td key={index}>
            {label}
          </td>
        ))}
      </tr>
    </thead>
  );
}

export default PersonalizedNutrientProfileLabels;
